/** @module csi/heading/RefImageBrowseController */
define([
	"dojo/_base/declare",
	"csi/action/_ImageBrowseMixin",
	"csi/heading/AttributeController",
	"csi/reflection"
], function(declare,_ImageBrowseMixin,AttributeController,reflection) {

	return declare([AttributeController, _ImageBrowseMixin], {
		bOneImage: true,

		onStart: function() {
			if (this.keyContainer === reflection.DEFAULT_IMAGE_LABEL) {
				// allow multiple images to upload if the column is image column 
				this.bOneImage = false;
			} else {
				// if changing labeled image, then it is possible it becomes the default image. So in that case,
				// need to redraw the whole node rather than just the current cell.
				this.bRefreshNode = true;
			}

			this.inherited(arguments);
		},
		
		process: function() {
			// summary: store selected image as new value and cache for viewing
			this.newValue = this._imageUrls[0];
			this.inherited(arguments);
		},
		
		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: save selected image to attribute
			return this._toWriterImages(id, type);
		}
	});
});